import { useState } from "react";
import SideBar from "../../../components/SideBar";
import Navigation from "../../../components/Navigation";
import Footer from "../../../components/Footer";
import LogOutModal from "../../../components/modals/LogOutModal";
import AdminUsersTable from "../../../components/tables/AdminUsersTable";
import CreateAdminUserModal from "../../../components/modals/admins/CreateAdminUserModal";
import EditAdminUserModal from "../../../components/modals/admins/EditAdminUserModal";
import LoadingModal from "../../../components/modals/LoadingModal";
import { useSelector } from "react-redux";

const AdminIndex = () => {
  const [open, setOpen] = useState(false);

  const [openCreateAdminUserModal, setOpenCreateAdminUserModal] = useState(false);
  const [openEditAdminUserModal, setOpenEditAdminUserModal] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [adminData, setAdminData] = useState({});
  const { loading } = useSelector((state) => state.admins);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const toggleLogOutModal = () => {
    setOpen(!open);
  };

  const toggleCreateAdminUserModal = () => {
    setOpenCreateAdminUserModal(!openCreateAdminUserModal);
  };

  const toggleEditAdminUserModal = (data) => {
    setAdminData(data)
    setOpenEditAdminUserModal(!openEditAdminUserModal);
  };

  const pageTitle = "Admin";
  const breadcrumbs = [{ text: "Home", link: "/" }, { text: "Admin" }];

  return (
    <div className="m-0 font-sans antialiased font-normal text-base leading-default bg-gray-50 text-slate-500">
      <SideBar
        options={{ open, toggleLogOutModal }}
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
      />

      <main className="ease-soft-in-out xl:ml-68.5 relative h-full max-h-screen rounded-xl transition-all duration-200">
        <Navigation
          pageTitle={pageTitle}
          breadcrumbs={breadcrumbs}
          isSidebarOpen={isSidebarOpen}
          toggleSidebar={toggleSidebar}
        />

        <div className="w-full px-6 py-6 mx-auto">
          <AdminUsersTable options={{ toggleCreateAdminUserModal, toggleEditAdminUserModal }} />
          <Footer />
        </div>
      </main>
      <LogOutModal options={{ open, setOpen, toggleLogOutModal }} />

      <CreateAdminUserModal
        options={{
          openCreateAdminUserModal,
          setOpenCreateAdminUserModal,
          toggleLogOutModal,
        }}
      />

      <EditAdminUserModal  options={{openEditAdminUserModal, setOpenEditAdminUserModal, adminData}}/>
      <LoadingModal options={{loading, setOpen}} />
    </div>
  );
};

export default AdminIndex;
